import actionConstants from '../constants/ActionConstants';

const initialState = {
  error: '',
  isfetching: false,
  planData: null,
  isSuccess: false,
  success: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionConstants.USER_PLAN_SUBSCRIPTION_REQUEST:
      return {
        ...state,
        isfetching: true,
        isSuccess: false,
        success: '',
      };
    case actionConstants.USER_PLAN_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        planData: action.payload,
        isfetching: false,
        isSuccess: true,
        success: action.message,
      };
    case actionConstants.USER_PLAN_SUBSCRIPTION_FAILURE:
      return {
        ...state,
        error: action.message,
        isfetching: false
      };
    case actionConstants.USER_PLAN_SUBSCRIPTION_CLEAR:
      return {
        ...state,
        planData: null,
        isSuccess: false,
        isfetching: false,
        error: '',
        success: '',
      };
    default:
      return state;
  }
};
